import { APIResponse, fetchUsingGet } from "../../utils/network";

export interface Token {
	token: string;
}

export const getTableauToken = async (): Promise<APIResponse<Token>> =>
  await fetchUsingGet("views/token");
